import { X, CheckCircle, AlertTriangle, AlertCircle } from "lucide-react";

const Notification = ({ type = "success", message, onClose }) => {
  const models = {
    success: {
      bg: "bg-green-50 border-green-500 text-green-700",
      icon: <CheckCircle className="text-green-600" size={22} />,
    },
    error: {
      bg: "bg-red-50 border-red-500 text-red-700",
      icon: <AlertCircle className="text-red-600" size={22} />,
    },
    warning: {
      bg: "bg-yellow-50 border-yellow-500 text-yellow-700",
      icon: <AlertTriangle className="text-yellow-600" size={22} />,
    },
    info: {
      bg: "bg-yellow-50 border-yellow-500 text-yellow-700",
      icon: <AlertTriangle className="text-yellow-600" size={22} />,
    },
  };

  return (
    <div
      className={`fixed top-4 right-4 z-[9999] flex items-center gap-3 border-l-4 px-4 py-3 rounded-lg shadow-lg w-96 animate-slide-in
        ${models[type].bg}`}
    >
      {models[type].icon}
      <div className="flex-1">
        <h4 className="font-semibold capitalize">{type}</h4>
        <p className="text-sm">{message}</p>
      </div>
      <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
        <X size={18} />
      </button>
    </div>
  );
};

export default Notification;
